import React from 'react';

import { Box } from '@chakra-ui/react';

/** Drag the panel's left edge to resize it; the width follows the pointer. */
export const DocsPanelResizeHandle = ({
  onResize,
}: {
  onResize: (width: number) => void;
}) => {
  const startDrag = (event: React.PointerEvent) => {
    event.preventDefault();
    const move = (moveEvent: PointerEvent) =>
      onResize(window.innerWidth - moveEvent.clientX);
    const stop = () => {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', stop);
      document.body.style.removeProperty('user-select');
    };
    // No text selection while dragging across the app.
    document.body.style.userSelect = 'none';
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', stop);
  };
  return (
    <Box
      role="separator"
      aria-orientation="vertical"
      aria-label="Resize the guide"
      position="absolute"
      left="-3px"
      top={0}
      bottom={0}
      w="6px"
      cursor="col-resize"
      zIndex={1}
      _hover={{ bg: 'primary', opacity: 0.4 }}
      onPointerDown={startDrag}
    />
  );
};
